/**
 * 言語設定コンポーネント
 *
 * 設定パネル内で表示する表示言語切り替えUI。
 * 「表示言語」見出しと日本語/Englishの選択を提供する。
 */
import { useLanguage } from '../hooks/useLanguage';
import LanguageSwitcher from './LanguageSwitcher';
import './LanguageSettings.css';

/**
 * 言語設定コンポーネント
 */
const LanguageSettings: React.FC = () => {
  const lang = useLanguage();

  return (
    <div className="language-settings">
      <div className="language-settings__header">
        <h4 className="language-settings__title">
          {lang === 'ja' ? '表示言語' : 'Display language'}
        </h4>
      </div>
      <LanguageSwitcher />
    </div>
  );
};

export default LanguageSettings;
